module.exports = __webpack_public_path__ + "officialStatic/img/modeBg.167ba79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/modeBg.jpg
// module id = X7mF
// module chunks = 0